import React from 'react'
import './UserInput.css'

const UserInput = (props, {name, required, type, placeholder, value, onChange }) => {
    return (
        <input
            name={name ? name : ''}
            required={required ? required : false}
            autoComplete='off'
            type={type ? type : 'text'}
            placeholder={placeholder ? placeholder : ''}
            className='userInput'
            onChange={onChange}
            value={value ? value : ''}
            {...props}
        />
    )
}

export default UserInput
